import styled from "styled-components";
import { FormWrapper, OrangeAccentCard } from "../../../styles/shared";

export const OperatorNewWrapper = styled.div`
  background: #0a0e27;
  min-height: 100vh;
  position: relative;
  margin: calc(-24px - 1.5rem - 4.375rem) -24px 0 -24px;
  padding-top: calc(4.375rem + 1.5rem);
`;

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 16px 0 16px;
  
  @media (min-width: 768px) {
    padding: 24px 24px 0 24px;
  }
  
  @media (min-width: 1200px) {
    padding: 24px 72px 0 72px;
  }
`;

export const OperatorCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px !important;
  
  @media (min-width: 768px) {
    padding: 32px !important;
  }
`;

export const CardTitle = styled.h2`
  color: #f29205;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);
  
  @media (min-width: 768px) {
    font-size: 24px;
    margin-bottom: 32px;
    gap: 12px;
  }
  
  i {
    font-size: 22px;
    color: #ff6b35;
    filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.5));
    
    @media (min-width: 768px) {
      font-size: 28px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-wrap: wrap;
  gap: 12px;
  
  @media (min-width: 768px) {
    margin-top: 32px;
    padding-top: 24px;
    gap: 16px;
  }
  
  a {
    text-decoration: none;
  }
  
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 10px;
    
    > a {
      width: 100%;
      display: block;
    }
    
    .mobile-button,
    > a .mobile-button,
    > .mobile-button {
      width: 100% !important;
      justify-content: center !important;
      padding: 10px 20px !important;
      font-size: 14px !important;
      height: 44px !important;
      min-height: 44px !important;
      max-height: 44px !important;
      
      & > span {
        font-size: 14px !important;
      }
      
      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }
`;

export const StyledFormWrapper = styled(FormWrapper)`
  @media (max-width: 767px) {
    .MuiFormControl-root {
      .MuiOutlinedInput-root {
        height: 48px !important;
        min-height: 48px !important;
        
        .MuiInputBase-input {
          height: 48px !important;
          padding: 12px 14px !important;
          font-size: 14px !important;
        }
      }
      
      .MuiInputLabel-root {
        font-size: 14px !important;
      }
      
      .MuiButton-root {
        height: 48px !important;
        min-height: 48px !important;
      }
    }
  }
`;

// Re-exportar FormWrapper
export { FormWrapper };

